import axios from "axios";
import { server, userInterface } from "../../app/consts";

axios.defaults.withCredentials = true;

export const login = async (credentials: { username: string; password: string }) => {
    try {
        const res = await axios.post(server + 'login', credentials);
        return res.data;
    } catch (err: any) {
        const msg = err.response?.data?.detail || "שם משתמש או סיסמא שגויים";
        console.error("Action failed\n",msg)
        return Promise.reject(err);
    }
};

export const logout = async () => {
    try {
        const res = await axios.post(server + 'logout');
        return res.data;
    } catch (err: any) {
        const msg = err.response?.data?.detail || "אירעה שגיאה";
        console.error("Action failed\n",msg)
        return Promise.reject(err);
    }
};

export const checkAuth = async () => {
    try {
        const res = await axios.get(server + 'checkLogged')
        return res.data;
    } catch (err: any) {
        const msg = err.response?.data?.detail || "אירעה שגיאה";
        console.error("Action failed\n",msg)
        return Promise.reject(err);
    }
};

export const addUser = async (data: userInterface) => {
    try {
        const res = await axios.post(server + 'addUser', data)
        return res.data;
    }
    catch (error: any) {
        console.error("Add User Failed\n", error)
        return Promise.reject(error)
    }
}

export const getAllUsers = async () => {
    try {
        const res = await axios.get(server + 'getAllUsers')
        return res.data;
    }
    catch (error: any) {
        console.error("get Users Failed\n", error)
        return Promise.reject(error)
    }
}

export const updateUserActiveStatus = async (username: string) => {
    try {
        const res = await axios.patch(server + 'updateUserActiveStatus', { "username": username })
        return res.data;
    }
    catch (error: any) {
        console.error("update User Failed\n", error)
        return Promise.reject(error)
    }
}

export const updateUserPhoneNum = async (data: { username: string, phone_num: string }) => {
    try {
        const res = await axios.patch(server + 'updateUserPhoneNum', { "username": data.username, "phone_num": data.phone_num })
        return res.data;
    }
    catch (error: any) {
        console.error("update User Failed\n", error)
        return Promise.reject(error)
    }
}

export const updateUserMfaStatus = async (username: string) => {
    try {
        const res = await axios.patch(server + 'updateMfaStatus', { "username": username })
        return res.data;
    }
    catch (error: any) {
        console.error("update User Failed\n", error)
        return Promise.reject(error)
    }
}